import httpClient from "@/services/httpClient";
import {
    server
} from "@/services/constants";

export const getAlldecision = () => {
    return httpClient.get(server.DECISION + `/getAll`);
};

export const getdecisionById = (id) => {
    return httpClient.get(server.DECISION + `/getById/${id}`);
};

export const getdecisiongetByAppId = (appointmentId, type) => {
    return httpClient.get(server.DECISION + `/getByAppId/${appointmentId}/${type}`);
};

export const createdecision = (data) => {
    return httpClient.post(server.DECISION, data);
};

export const updatedecision = (id, data) => {
    return httpClient.put(server.DECISION + `/${id}`, data);
};


export const deletedecision = (id) => {
    return httpClient.delete(server.DECISION + `/${id}`);
};